export const FIELD_MAPPINGS = {
  period: 'periodName',
  enabledflag: 'enabledFlag',
  exceptionaccount: 'exceptionAccount',
  exceptionbasis: 'exceptionBasis',
  disallowedpercentage: 'disallowedPercentage',
  booktotaxcodedescription: 'tagDescription',
  connections: 'connections',
  businessunits: 'businessUnits',
  excludedcompanycodes: 'excludedCompanyCodes',
  countrytaxtypes: 'countryTaxTypes',
  exceptionid: 'exceptionId',
};
export const MIN_COLUMNS_NUMBER = 11;
export const MAX_COLUMNS_NUMBER = 11;
